import xs1Device from './xs1-device';
import xs1Subscriptions from './xs1-subscriptions';
import xs1Accessories from './xs1-accessories';
import xp1 from './xp1';
import xs1AccessoryTree from './xs1-accessory-tree';

export default [...xs1Device, ...xs1Subscriptions, ...xs1Accessories, ...xp1, ...xs1AccessoryTree];
